import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { subscribeToAuthChanges } from '../../utils/auth';
import { AdminUser } from '../../types/admin';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [adminUser, setAdminUser] = useState<AdminUser | null>(null);
  const location = useLocation();

  useEffect(() => {
    // Subscribe to auth state changes
    const unsubscribe = subscribeToAuthChanges((user) => {
      setIsAuthenticated(!!user);
      setAdminUser(user);
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);

  // Show loading state while checking authentication
  if (isAuthenticated === null) {
    return (
      <div className="admin-loading">
        <h2>Loading...</h2>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated || !adminUser) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // TODO: [FIRESTORE-INTEGRATION] Add additional role-based access control here
  // You can check adminUser.role or custom claims to ensure proper authorization

  // Render protected content if authenticated
  return <>{children}</>;
};
